import { Accessor, Setter, createContext, useContext } from "solid-js";
import { DateCategory, DateEvent } from "../../types/date";

interface DatesContextInterface {
	event: Accessor<DateEvent | undefined>;
	events: Accessor<DateEvent[]>;
	oncomingEvents: Accessor<DateEvent[]>;
	categories: Accessor<DateCategory[]>;
	category: Accessor<string>;
	state: Accessor<"loading" | "idle" | "error">;
	listRef: Accessor<HTMLDivElement | null>;

	setCategory: (value: string) => void;
	setEvent: Setter<DateEvent | undefined>;
	setListRef: Setter<HTMLDivElement | null>;

	formatDate: (event?: DateEvent) => string;
	formatTime: (event: DateEvent) => string;

	openContentDialog: Accessor<boolean>;
	setOpenContentDialog: Setter<boolean>;
}

export const DatesContext = createContext<DatesContextInterface>();

export function useDateWidget() {
	const context = useContext(DatesContext);
	if (!context) throw new Error("DatesContext is not provided");
	return context;
}